/* Filantrópico — el único JavaScript del tema.
   1) Modo oficina (QR): recuerda la oficina y cambia el texto del envío.
   2) Ficha de café: elige la variante con botones, cuenta unidades y escribe el resumen. */
(function () {
  'use strict';

  /* ---------- 1) Modo oficina ---------- */
  var params = new URLSearchParams(location.search);
  var oficina = params.get('oficina');
  /* El enlace del QR es /discount/OFICINA-NOMBRE?redirect=/pages/oficina: Shopify guarda el código
     en la cookie discount_code y lo aplica en el pago. De ahí sacamos el nombre de la oficina. */
  if (!oficina) {
    var cookieDescuento = (document.cookie.match(/(?:^|;\s*)discount_code=([^;]+)/) || [])[1];
    if (cookieDescuento) {
      cookieDescuento = decodeURIComponent(cookieDescuento).toUpperCase();
      if (cookieDescuento.indexOf('OFICINA-') === 0) {
        oficina = cookieDescuento.slice(8).toLowerCase();
      }
    }
  }
  var enLanding = location.pathname.indexOf('/pages/oficina') === 0;
  var enCasa = location.pathname.indexOf('/collections/') === 0;
  try {
    if (enCasa) { sessionStorage.removeItem('oficina'); oficina = null; }
    else if (oficina) { sessionStorage.setItem('oficina', oficina); }
    else if (enLanding) { oficina = '1'; sessionStorage.setItem('oficina', oficina); }
    else { oficina = sessionStorage.getItem('oficina'); }
  } catch (e) { if (enLanding && !oficina) { oficina = '1'; } }
  /* Si hay cookie de código de oficina, el modo oficina vale en toda la visita (también tras entrar en Café para tu casa). */
  if (!oficina) {
    var cookieOficina = (document.cookie.match(/(?:^|;\s*)discount_code=([^;]+)/) || [])[1];
    if (cookieOficina && decodeURIComponent(cookieOficina).toUpperCase().indexOf('OFICINA-') === 0) {
      oficina = decodeURIComponent(cookieOficina).slice(8).toLowerCase();
    }
  }
  var enOficina = !!oficina;

  /* Nombre de la oficina a partir del código (OFICINA-RATED-POWER → «Rated Power»).
     Las siglas se quedan en mayúsculas y los nombres con acento tienen su forma exacta. */
  var SIGLAS = ['BCG', 'BHS', 'BMS', 'HDI', 'GMP', 'MUFG', 'RZS', 'SAP', 'PMK', 'UAX', 'GI', 'SEMI', 'AI', 'COFIDES', 'AT', 'DLA'];
  var NOMBRES = {
    'CONDE-NAST': 'Condé Nast',
    'OXFAM-INTERMON': 'Oxfam Intermón',
    'LA-NUBE-SOFAS': 'La Nube Sofás',
    'ASISA-MIGUEL-ANGEL': 'Asisa Miguel Ángel',
    'INTERECONOMIA': 'Intereconomía',
    'CHANEL-MARIA-DE-MOLINA': 'Chanel María de Molina',
    'PIONAIR': 'PionAirLaw',
    'UAX-VILLANUEVA': 'UAX Villanueva de la Cañada',
    'ARANZADI-LA-LEY': 'Aranzadi LA LEY',
    'ABAI-GROUP': 'ABAI Group',
    'DLA-PIPER': 'DLA Piper',
    'BHS': 'BHSI',
    'HERBERT-SMITH': 'HSF Kramer',
    'PANORAMA-HOTELS': 'Panoram',
    'RATED-POWER': 'RatedPower',
    'GI-GROUP-CASTELLANA': 'Gi Group',
    'EL-TIEMPO': 'ElTiempo.es',
    'MADRIMASD': 'madri+d',
    'MJOLNER': 'Mjølner',
    'ASISA-LUCA-DE-TENA': 'ASISA Luca de Tena',
    'ASISA-MIGUEL-ANGEL': 'ASISA Miguel Ángel',
    'AVEVA': 'AVEVA',
    'OFESAUTO': 'OFESAUTO',
    'SIGMA': 'Sigma AI',
    'ARCANO': 'Arcano Partners',
    'CARDUMEN': 'Cardumen Capital',
    'COBAS': 'Cobas AM',
    'DONTE': 'Donte Group',
    'EVERWOOD': 'Everwood Capital',
    'FUNDACIO-VILLAVECCHIA': 'Fundació Enriqueta Villavecchia',
    'CAIXABANK-PAYMENTS': 'CaixaBank Payments & Consumer',
    'CAIXABANK-FACILITIES': 'CaixaBank Facilities Management'
  };
  function nombreOficina(codigo) {
    var clave = decodeURIComponent(codigo).toUpperCase();
    if (NOMBRES[clave]) { return NOMBRES[clave]; }
    return clave.replace(/[-_+]/g, ' ').split(' ').map(function (p) {
      if (SIGLAS.indexOf(p) !== -1) { return p; }
      if (p === 'DE' || p === 'Y') { return p.toLowerCase(); }
      return p.charAt(0) + p.slice(1).toLowerCase();
    }).join(' ');
  }

  document.querySelectorAll('[data-oficina-tag]').forEach(function (el) {
    if (enOficina) {
      el.hidden = false;
      if (el.hasAttribute('data-oficina-nombre') && oficina !== '1') {
        el.textContent = 'Tu oficina: ' + nombreOficina(oficina);
      }
    } else if (!el.hasAttribute('data-oficina-nombre')) {
      el.hidden = true;
    }
  });
  /* «te lo llevamos a tu oficina» pasa a «te lo llevamos a Adyen» cuando sabemos la sede. */
  var destinoEnvio = (enOficina && oficina !== '1') ? nombreOficina(oficina) : 'tu oficina';
  var textoEnvioOficina = 'Envío: gratis, te lo llevamos a ' + destinoEnvio + '.';
  document.querySelectorAll('[data-envio-normal]').forEach(function (el) { el.hidden = enOficina; });
  document.querySelectorAll('[data-envio-oficina]').forEach(function (el) {
    el.hidden = !enOficina;
    if (enOficina && el.textContent.indexOf('te lo llevamos a') !== -1) { el.textContent = textoEnvioOficina; }
  });
  if (enOficina) {
    document.querySelectorAll('[data-enlace-cafe]').forEach(function (a) {
      try { var u = new URL(a.href); u.searchParams.set('oficina', oficina); a.href = u.toString(); } catch (e) {}
    });
  }

  /* ---------- 1b) Formularios de Shopify Forms ----------
     La app dibuja el formulario dentro de un "shadow DOM" con colores y tamaños propios
     que no cumplen el contraste mínimo. Añadimos una hoja de estilos dentro para corregirlo. */
  var estilosForms = [
    ':host{font-family:"Atkinson Hyperlegible Next","Atkinson Hyperlegible",Verdana,sans-serif!important}',
    '*{font-family:inherit!important}',
    'label,[id^="label-"]{color:#4A4A4A!important;font-size:1rem!important}',
    'input,select,textarea{color:#00263D!important;font-size:1.1rem!important;border-color:#00263D!important;border-width:2px!important}',
    'p,span,div{font-size:1rem}',
    '[class*="formDisclaimer"]{margin:1rem 0 0!important}',
    '[class*="formDisclaimer"] p,[class*="formDisclaimer"]{font-size:.95rem!important;line-height:1.5!important;color:#00263D!important}',
    '[class*="textHeading"],[class*="textBody"]{display:none!important}',
    'button[type="submit"]{width:100%!important;padding-left:.75rem!important;padding-right:.75rem!important}',
    'button[type="submit"]{box-sizing:border-box!important;min-height:3.5rem!important;height:auto!important;padding:.8rem .75rem!important;line-height:1.2!important;border-radius:999px!important;font-weight:800!important;font-size:1.15rem!important}',
    /* El botón de la bandera del teléfono: sin el relleno del botón grande, para que la bandera se vea entera. */
    'button[class*="selectToggle"]{padding:0 .6rem!important;min-height:3.5rem!important;box-sizing:border-box!important}',
    '[class*="selectToggleText"]{overflow:visible!important;width:auto!important;min-width:1.7rem!important}',
    '*:focus-visible{outline:4px solid #00263D!important;outline-offset:4px!important}'
  ].join('\n');
  function arreglaForm(el) {
    if (!el.shadowRoot || el.shadowRoot.querySelector('style[data-filantropico]')) { return; }
    var st = document.createElement('style');
    st.setAttribute('data-filantropico', '');
    st.textContent = estilosForms;
    el.shadowRoot.appendChild(st);
  }
  function arreglaForms() { document.querySelectorAll('shopify-forms-embed').forEach(arreglaForm); }
  arreglaForms();
  if (document.querySelector('[data-form-root]')) {
    new MutationObserver(arreglaForms).observe(document.body, { childList: true, subtree: true });
    var intentos = 0;
    var t = setInterval(function () { arreglaForms(); if (++intentos > 40) { clearInterval(t); } }, 250);
  }

  /* ---------- 2) Ficha de café ---------- */
  var form = document.getElementById('form-producto');
  var datosEl = document.getElementById('datos-producto');
  if (!form || !datosEl) { return; }
  var datos;
  try { datos = JSON.parse(datosEl.textContent); } catch (e) { return; }

  var idInput = document.getElementById('id-variante');
  var cantidad = document.getElementById('cantidad');
  var resumen = document.getElementById('resumen');
  var boton = document.getElementById('boton-comprar');
  var envio = enOficina ? 0 : datos.envio;

  function eur(centimos) {
    var e = Math.floor(centimos / 100);
    var c = centimos % 100;
    var miles = e.toLocaleString('es-ES');
    return c === 0 ? miles + ' €' : miles + ',' + (c < 10 ? '0' + c : c) + ' €';
  }

  function seleccion() {
    var valores = [];
    for (var i = 1; i <= datos.opciones.length; i++) {
      var campo = form.querySelector('input[name="opcion-' + i + '"]:checked, input[type=hidden][name="opcion-' + i + '"]');
      valores.push(campo ? campo.value : null);
    }
    return valores;
  }

  function varianteActual() {
    var sel = seleccion();
    for (var i = 0; i < datos.variantes.length; i++) {
      var v = datos.variantes[i];
      var igual = true;
      for (var j = 0; j < sel.length; j++) { if (v.opciones[j] !== sel[j]) { igual = false; break; } }
      if (igual) { return v; }
    }
    return null;
  }

  function textoPreparacion(valor) {
    if (!valor) { return ''; }
    return valor === 'En grano' ? 'en grano' : 'molido para ' + valor.toLowerCase();
  }

  var planAyuda = form.querySelector('[data-plan-ayuda]');
  var sellingPlan = document.getElementById('selling-plan');

  function planElegido() {
    var radio = form.querySelector('input[name="plan"]:checked');
    if (radio) {
      if (sellingPlan) { sellingPlan.value = radio.value; }
      if (planAyuda) {
        if (radio.value && radio.getAttribute('data-ayuda')) {
          planAyuda.textContent = radio.getAttribute('data-ayuda');
          planAyuda.hidden = false;
        } else {
          planAyuda.hidden = true;
        }
      }
      if (!radio.value) { return null; }
      return radio.getAttribute('data-etiqueta') || datos.planes[radio.value] || 'Suscripción';
    }
    var campo = form.querySelector('input[name="selling_plan"]');
    if (!campo || !campo.value) { return null; }
    return datos.planes[campo.value] || 'Suscripción';
  }

  function pinta() {
    var v = varianteActual();
    var n = Math.min(50, Math.max(1, parseInt(cantidad.value, 10) || 1));
    cantidad.value = n;
    if (!v) {
      resumen.innerHTML = 'Esta combinación no está disponible.';
      boton.disabled = true;
      return;
    }
    idInput.value = v.id;
    var sel = seleccion();
    var partes = [];
    datos.opciones.forEach(function (nombre, i) {
      if (nombre === 'Cómo lo preparas') { partes.push(textoPreparacion(sel[i])); }
      else if (sel[i]) { partes.push(sel[i]); }
    });
    var unidad = datos.empresas ? (n === 1 ? 'kilo' : 'kilos') : (n === 1 ? 'unidad' : 'unidades');
    var cantidadTxt = partes.shift();
    var linea1 = '<b>' + datos.titulo + '.</b><br>' + cantidadTxt + ' × ' + n + ' ' + unidad + (partes.length ? ', ' + partes.join(', ') : '') + '.';
    var plan = planElegido();
    var linea2 = plan ? plan + '.' : 'Solo una vez.';
    var cafe = v.precio * n;
    var lineaCafe;
    if (datos.empresas) {
      var sinIva = Math.round(cafe / (1 + datos.iva / 100));
      lineaCafe = 'Café: ' + eur(sinIva) + ' + IVA. Con IVA: ' + eur(cafe) + '.';
    } else {
      lineaCafe = 'Café: ' + eur(cafe) + '.';
    }
    var lineaEnvio = enOficina ? textoEnvioOficina : 'Envío: ' + eur(envio) + '.';
    var total = cafe + envio;
    resumen.innerHTML = linea1 + '<br>' + linea2 + '<br>' + lineaCafe + ' ' + lineaEnvio + '<span class="total">Total: ' + eur(total) + '</span>';
    boton.disabled = !v.disponible;
    boton.lastChild.textContent = v.disponible ? ' Comprar' : ' No disponible ahora';
  }

  form.addEventListener('change', function (e) {
    if (e.target.name && e.target.name.indexOf('opcion-') === 0) {
      var v = varianteActual();
      if (v) {
        idInput.value = v.id;
        idInput.dispatchEvent(new Event('change', { bubbles: true }));
        try { history.replaceState(null, '', location.pathname + '?variant=' + v.id + (enOficina ? '&oficina=' + encodeURIComponent(oficina) : '')); } catch (err) {}
      }
    }
    pinta();
  });
  cantidad.addEventListener('input', pinta);
  form.querySelectorAll('[data-cantidad]').forEach(function (b) {
    b.addEventListener('click', function () {
      var n = parseInt(cantidad.value, 10) || 1;
      cantidad.value = Math.min(50, Math.max(1, n + parseInt(b.getAttribute('data-cantidad'), 10)));
      pinta();
    });
  });
  /* El bloque de suscripciones cambia el campo selling_plan al elegir; escuchamos cualquier cambio en la sección. */
  var seccion = form.closest('.shopify-section') || document;
  seccion.addEventListener('change', function () { setTimeout(pinta, 0); });
  seccion.addEventListener('click', function () { setTimeout(pinta, 0); });

  pinta();
})();
